// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { FaCalendarAlt, FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
// import { useTranslation } from "react-i18next";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";
// import TutorOrderForm from "./TutorserviceOrderForm";
// import heroImage from "../images/Tutor.png";
// import "./tutorserviceStyle.css";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const TutorService = () => {
//   const { t } = useTranslation();
//   const location = useLocation();

//   const rebookState = location.state?.fromRebook || false;
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   const [ratingData, setRatingData] = useState({ reviewCount: 0, avgRating: 0 });
//   const [useSameTutor, setUseSameTutor] = useState(false);
//   const [prevTutorName, setPrevTutorName] = useState("");
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [user, setUser] = useState(null);

//   const [formData, setFormData] = useState({
//     medium: "Bangla Medium",
//     classLevel: "",
//     subjects: [],
//     daysPerWeek: 1,
//     hoursPerDay: "1",
//     salaryPerMonth: "",
//     tutorRequirements: { university: "", gender: "" },
//     notes: "",
//     date: "",
//     time: "",
//     useSameTutor: false,
//     servitor_id: undefined,
//     price: 0,
//   });

//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };
//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   // Load user (via JWT), tutor ratings, and previous servitor name (if rebook)
//   useEffect(() => {
//     const run = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decoded = jwtDecode(token);
//           const userIdRaw = decoded.Id;
//           const extractedUserId = userIdRaw?.startsWith("user-")
//             ? userIdRaw.split("user-")[1]
//             : userIdRaw;

        
//         const userRes = await axios.get(`${URL}/user/${extractedUserId}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setUser(userRes.data);
//       } else {
//         setUser(null);
//       }

//         if (rebookState && prevOrder.servitor_id) {
//           try {
//             const s = await axios.get(`${URL}/servitors/${prevOrder.servitor_id}`);
//             const data = s.data;
//             setPrevTutorName(`${data.FirstName} ${data.LastName}`);
//           } catch (e) {
//             console.error("Error fetching servitor:", e);
//           }
//         }
//       } catch (err) {
//         console.error("Init error:", err);
//         // If we can't load user or ratings, still show page; prompt login if no user
//         if (!user) setShowLoginPrompt(true);
//       } finally { setLoading(false); }
//     };
//     run();
//     window.scrollTo(0, 0);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [rebookState, prevOrder.servitor_id]);

// //   useEffect(() => {
// //   axios
// //     .get(`${URL}/api/ratings`)
// //     .then(({ data }) => {
// //       const tutorRatings = data["tutor service"] || {};
// //       setRatingData({
// //         reviewCount: tutorRatings.reviewCount || 0,
// //         avgRating: tutorRatings.avgRating || 0,
// //       });
// //     })
// //     .catch((err) => {
// //       console.error("Failed to load tutor ratings:", err);
// //     });
// // }, []);

// useEffect(() => {
//     const loadRatings = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axios.get(`${URL}/api/ratings`);
//         // handle different backend key styles
//         const tutorRatings = data["tutor service"] || {};
//         setRatingData({
//           reviewCount: tutorRatings.reviewCount || 0,
//           avgRating: tutorRatings.avgRating || 0,
//         });
//       } catch (err) {
//         console.error("Failed to load ratings:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadRatings();
//   }, []);

//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) stars.push(<FaStar key={i} />);
//       else if (rating >= i - 0.5) stars.push(<FaStarHalfAlt key={i} />);
//       else stars.push(<FaRegStar key={i} />);
//     }
//     return stars;
//   };

//   // FIX: prevent 21:30 slot
//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21; // last slot should be 21:00
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     let startHour = startTime;
//     let startMinute = 0;

//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) return [];
//       if (currentHour >= startTime) {
//         if (currentMinute === 0) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         if (hour === endTime && minute > 0) break; // stop 21:30
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(2, "0")} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   const updateFormData = (key, value) => {
//     if (key === "tutorRequirements") {
//       setFormData((prev) => ({
//         ...prev,
//         tutorRequirements: { ...prev.tutorRequirements, ...value },
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [key]: value }));
//     }
//   };

//   // Populate from previous order on rebook
//   useEffect(() => {
//     if (rebookState && prevOrder) {
//       setFormData((prev) => ({
//         ...prev,
//         medium: prevOrder.medium || "Bangla Medium",
//         classLevel: prevOrder.classLevel || "",
//         subjects: prevOrder.subjects || [],
//         daysPerWeek: prevOrder.daysPerWeek || 1,
//         hoursPerDay: prevOrder.hoursPerDay || "1",
//         salaryPerMonth: prevOrder.salaryPerMonth || 0,
//         tutorRequirements: prevOrder.tutorRequirements || { university: "", gender: "" },
//         notes: prevOrder.notes || "",
//       }));
//     }
//   }, [rebookState, prevOrder]);

//   const [subjectSearch, setSubjectSearch] = useState("");
//   const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);

//   const validateForm = () => {
//     if (!formData.medium) return t("tutor.form.errors.medium");
//     if (!formData.classLevel) return t("tutor.form.errors.classLevel");
//     if (!formData.subjects.length) return t("tutor.form.errors.subjects");
//     if (!formData.daysPerWeek) return t("tutor.form.errors.daysPerWeek");
//     if (!formData.hoursPerDay) return t("tutor.form.errors.hoursPerDay");
//     if (!formData.salaryPerMonth) return t("tutor.form.errors.salaryPerMonth");
//     return null;
//   };

//   // Main form submit -> open modal (modal actually POSTs)
//   const handleGetService = (e) => {
//     e.preventDefault();
//     const error = validateForm();
//     if (error) return alert(error);

//     const dateStr = selectedDate ? selectedDate.toISOString().split("T")[0] : "";
//     const time = e.target.time.value;

//     const updated = {
//       ...formData,
//       date: dateStr,
//       time,
//       price: formData.salaryPerMonth,
//       useSameTutor,
//       servitor_id: useSameTutor ? prevOrder.servitor_id : undefined,
//     };
//     setFormData(updated);

//     // if (user) setShowOrderForm(true);
//     // else setShowLoginPrompt(true);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // After modal successfully posts, reset page state
//   const handleOrderSubmit = () => {
//     setFormData({
//       medium: "Bangla Medium",
//       classLevel: "",
//       subjects: [],
//       daysPerWeek: 1,
//       hoursPerDay: "1",
//       salaryPerMonth: 0,
//       tutorRequirements: { university: "", gender: "" },
//       notes: "",
//       date: "",
//       time: "",
//       useSameTutor: false,
//       servitor_id: undefined,
//       price: 0,
//     });
//     setUseSameTutor(false);
//     setSubjectSearch("");
//     setShowOrderForm(false);
//   };

//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const handleIncrement = () => setValue(value < max ? value + 1 : value);
//     const handleDecrement = () => setValue(value > min ? value - 1 : value);
//     return (
//       <div className="TutorService-plusMinusInput">
//         <button
//           type="button"
//           className="TutorService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//           aria-label={`Decrease ${id} quantity`}
//         >
//           −
//         </button>
//         <span className="TutorService-valueDisplay">{value} {t("tutor.form.days")}</span>
//         <button
//           type="button"
//           className="TutorService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//           aria-label={`Increase ${id} quantity`}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   const subjectsList = [
//     "Quran Sharif Learning",
//     "All",
//     "Bangla",
//     "English",
//     "Mathematics",
//     "General Science",
//     "Social Science",
//     "Religion",
//     "ICT",
//     "Higher Mathematics",
//     "Physics",
//     "Chemistry",
//     "Biology",
//     "Economics",
//     "Statistics",
//     "Psychology",
//   ];

//   const filteredSubjects = subjectsList.filter((subject) =>
//     subject.toLowerCase().includes(subjectSearch.toLowerCase())
//   );

//   const classLevels = {
//     "Bangla Medium": [
//       "KG",
//       "Nursery",
//       "Play",
//       "Class 1",
//       "Class 2",
//       "Class 3",
//       "Class 4",
//       "Class 5",
//       "Class 6",
//       "Class 7",
//       "Class 8",
//       "Class 9",
//       "Class 10",
//       "SSC",
//       "HSC 1st Year",
//       "HSC 2nd Year",
//       "Admission Test",
//     ],
//     "English Medium": [
//       "Play",
//       "KG",
//       "Nursery",
//       "Standard 1",
//       "Standard 2",
//       "Standard 3",
//       "Standard 4",
//       "Standard 5",
//       "Standard 6",
//       "Standard 7",
//       "Standard 8",
//       "Standard 9",
//       "Pre-Schooling",
//       "O Level",
//       "A Level (AS)",
//       "A Level (A2)",
//     ],
//     "English Version": [
//       "KG",
//       "Nursery",
//       "Play",
//       "Class 1",
//       "Class 2",
//       "Class 3",
//       "Class 4",
//       "Class 5",
//       "Class 6",
//       "Class 7",
//       "Class 8",
//       "Class 9",
//       "Class 10",
//       "SSC",
//       "HSC 1st Year",
//       "HSC 2nd Year",
//       "Admission Test",
//     ],
//   };


//   const UNI_OPTIONS = useMemo(
//   () => [
//     { value: "BUET", label: t("tutor.universities.buet", { defaultValue: "BUET" }) },
//     { value: "Medical", label: t("tutor.universities.medical", { defaultValue: "Medical" }) },
//     { value: "Quran", label: t("tutor.universities.madrasa", { defaultValue: "Quran/Islamic Education" }) },
//     { value: "DU", label: t("tutor.universities.du", { defaultValue: "Dhaka University" }) },
//     { value: "Public University", label: t("tutor.universities.public", { defaultValue: "Public University" }) },
//     { value: "Private University", label: t("tutor.universities.private", { defaultValue: "Private University" }) },
//   ],
//   [t]
// );

//   return (
//     <>
//       <div className="TutorService-container">
//         <Navbar />
//         <Loader show={loading} />

//         <div className="TutorService-card">
//           <div className="TutorService-hero">
//             <img src={heroImage} alt="Tutor Services Hero" />
//           </div>

//           <div className="TutorService-header">
//             <h1>{t(rebookState ? "tutor.header.rebook_title" : "tutor.header.title")}</h1>
//             <div className="TutorService-rating">{renderStars(ratingData.avgRating)}</div>
//             <div className="TutorService-reviews">
//               {ratingData.reviewCount.toLocaleString()} {t("tutor.reviewsLabel")}
//             </div>
//           </div>

//           {/* <div className="TutorService-categories">
//             <div className="TutorService-category">
//               <h5>
//                 <span className="TutorService-categoryIcon">📚</span>
//                 {t("tutor.categories.academic.title")}
//               </h5>
//               <p className="TutorService-serviceDescription">{t("tutor.categories.academic.description")}</p>
//             </div>
//             <div className="TutorService-category">
//               <h5>
//                 <span className="TutorService-categoryIcon">🎓</span>
//                 {t("tutor.categories.exam_prep.title")}
//               </h5>
//               <p className="TutorService-serviceDescription">{t("tutor.categories.exam_prep.description")}</p>
//             </div>
//           </div> */}

//           <form onSubmit={handleGetService} className="TutorService-form">
//             <h3 className="TutorService-sectionTitle">
//               <i className="fas fa-book" />
//               {t("tutor.form.sections.academic_details.title")}
//             </h3>

//             <div className="TutorService-serviceOptions">
//               <div className="TutorService-optionGroup TutorService-fullWidth">
//                 {/* <label htmlFor="medium">{t("tutor.form.sections.academic_details.labels.medium")}</label> */}
//                 <label htmlFor="medium" className="tooltip-label">
//                     {t("tutor.form.sections.academic_details.labels.medium")}
//                     <ServiceTooltip
//                       title={t("tutor.tooltips.medium.title")}
//                       description={t("tutor.tooltips.medium.description")}
//                     />
//                   </label>
//                 <select
//                   id="medium"
//                   value={formData.medium}
//                   onChange={(e) => {
//                     updateFormData("medium", e.target.value);
//                     updateFormData("classLevel", "");
//                   }}
//                   required
//                   className="TutorService-wideSelect"
//                 >
//                   <option value="Bangla Medium">{t("tutor.form.sections.academic_details.options.bangla_medium")}</option>
//                   <option value="English Medium">{t("tutor.form.sections.academic_details.options.english_medium")}</option>
//                   <option value="English Version">{t("tutor.form.sections.academic_details.options.english_version")}</option>
//                 </select>
//               </div>

//               <div className="TutorService-optionGroup TutorService-fullWidth">
//                 {/* <label htmlFor="classLevel">{t("tutor.form.sections.academic_details.labels.classLevel")}</label> */}
//                 <label htmlFor="classLevel" className="tooltip-label">
//                   {t("tutor.form.sections.academic_details.labels.classLevel")}
//                   <ServiceTooltip
//                     title={t("tutor.tooltips.classLevel.title")}
//                     description={t("tutor.tooltips.classLevel.description")}
//                   />
//                 </label>
//                 <select
//                   id="classLevel"
//                   value={formData.classLevel}
//                   onChange={(e) => updateFormData("classLevel", e.target.value)}
//                   required
//                   className="TutorService-wideSelect"
//                 >
//                   <option value="">{t("tutor.form.sections.academic_details.options.select")}</option>
//                   {classLevels[formData.medium].map((opt) => (
//                     <option key={opt} value={opt}>{opt}</option>
//                   ))}
//                 </select>
//               </div>

//               <div className="TutorService-optionGroup TutorService-fullWidth">
//                 {/* <label>{t("tutor.form.sections.academic_details.labels.subjects")}</label> */}
//                 <label htmlFor="subjects-search" className="tooltip-label">
//         {t("tutor.form.sections.academic_details.labels.subjects")}
//         <ServiceTooltip
//           title={t("tutor.tooltips.subjects.title")}
//           description={t("tutor.tooltips.subjects.description")}
//         />
//       </label>

//                 {formData.subjects.length > 0 && (
//                   <div className="TutorService-selectedSubjects">
//                     {formData.subjects.map((subject) => (
//                       <span key={subject} className="TutorService-subjectTag">
//                         {subject}
//                         <button
//                           type="button"
//                           onClick={() =>
//                             updateFormData("subjects", formData.subjects.filter((s) => s !== subject))
//                           }
//                           className="TutorService-removeSubject"
//                         >
//                           ×
//                         </button>
//                       </span>
//                     ))}
//                   </div>
//                 )}

//                 <div className="TutorService-subjectSearchWrapper">
//                   <input
//                     type="text"
//                     value={subjectSearch}
//                     onChange={(e) => setSubjectSearch(e.target.value)}
//                     onFocus={() => setShowSubjectDropdown(true)}
//                     onBlur={() => setTimeout(() => setShowSubjectDropdown(false), 200)}
//                     placeholder={t("tutor.form.sections.academic_details.placeholders.subjects")}
//                     className="TutorService-subjectSearch"
//                   />
//                   {showSubjectDropdown && (
//                     <div className="TutorService-subjectDropdown">
//                       {filteredSubjects.length ? (
//                         filteredSubjects.map((subject) => (
//                           <label key={subject} className="TutorService-subjectOption">
//                             <input
//                               type="checkbox"
//                               value={subject}
//                               checked={formData.subjects.includes(subject)}
//                               onChange={(e) => {
//                                 const updatedSubjects = e.target.checked
//                                   ? [...formData.subjects, subject]
//                                   : formData.subjects.filter((s) => s !== subject);
//                                 updateFormData("subjects", updatedSubjects);
//                               }}
//                             />
//                             {subject}
//                           </label>
//                         ))
//                       ) : (
//                         <div className="TutorService-noResults">
//                           {t("tutor.form.sections.academic_details.no_subjects")}
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>

//             <h3 className="TutorService-sectionTitle">
//               <i className="fas fa-calendar-week" />
//               {t("tutor.form.sections.schedule.title")}
//             </h3>

//             <div className="TutorService-serviceOptions">
//               <div className="TutorService-optionGroup">
//                 {/* <label htmlFor="daysPerWeek">{t("tutor.form.sections.schedule.labels.daysPerWeek")}</label> */}
//                 <label htmlFor="daysPerWeek" className="tooltip-label">
//         {t("tutor.form.sections.schedule.labels.daysPerWeek")}
//         <ServiceTooltip
//           title={t("tutor.tooltips.daysPerWeek.title")}
//           description={t("tutor.tooltips.daysPerWeek.description")}
//         />
//       </label>
//                 <PlusMinusInput
//                   id="daysPerWeek"
//                   value={formData.daysPerWeek}
//                   setValue={(val) => updateFormData("daysPerWeek", val)}
//                   min={1}
//                   max={7}
//                 />
//               </div>

//               <div className="TutorService-optionGroup">
//                 {/* <label htmlFor="hoursPerDay">{t("tutor.form.sections.schedule.labels.hoursPerDay")}</label> */}
//                 <label htmlFor="hoursPerDay" className="tooltip-label">
//         {t("tutor.form.sections.schedule.labels.hoursPerDay")}
//         <ServiceTooltip
//           title={t("tutor.tooltips.hoursPerDay.title")}
//           description={t("tutor.tooltips.hoursPerDay.description")}
//         />
//       </label>
//                 <select
//                   id="hoursPerDay"
//                   value={formData.hoursPerDay}
//                   onChange={(e) => updateFormData("hoursPerDay", e.target.value)}
//                   required
//                 >
//                   {["1", "1.5", "2", "2.5", "3"].map((opt) => (
//                     <option key={opt} value={opt}>
//                       {opt} {t("tutor.form.hours")}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <h3 className="TutorService-sectionTitle">
//               <i className="fas fa-money-bill" />
//               {t("tutor.form.sections.budget_requirements.title")}
//             </h3>

//             <div className="TutorService-serviceOptions">
//               <div className="TutorService-optionGroup">
//                 {/* <label htmlFor="salaryPerMonth">
//                   {t("tutor.form.sections.budget_requirements.labels.salaryPerMonth")}
//                 </label> */}

//                 <label htmlFor="salaryPerMonth" className="tooltip-label">
//         {t("tutor.form.sections.budget_requirements.labels.salaryPerMonth")}
//         <ServiceTooltip
//           title={t("tutor.tooltips.salaryPerMonth.title")}
//           description={t("tutor.tooltips.salaryPerMonth.description")}
//         />
//       </label>

//                 <input
//                   id="salaryPerMonth"
//                   type="number"
//                   value={formData.salaryPerMonth}
//                   onChange={(e) => updateFormData("salaryPerMonth", Number(e.target.value))}
//                   placeholder={t("tutor.form.sections.budget_requirements.placeholders.salaryPerMonth")}
//                   required
//                 />
//               </div>

//               <div className="TutorService-optionGroup">
//                 {/* <label htmlFor="university">
//                   {t("tutor.form.sections.budget_requirements.labels.university")}
//                 </label> */}
//                 <label htmlFor="university" className="tooltip-label">
//         {t("tutor.form.sections.budget_requirements.labels.university")}
//         <ServiceTooltip
//           title={t("tutor.tooltips.university.title")}
//           description={t("tutor.tooltips.university.description")}
//         />
//       </label>

//                 {/* <select
//                   id="university"
//                   value={formData.tutorRequirements.university}
//                   onChange={(e) => updateFormData("tutorRequirements", { university: e.target.value })}
//                 >
//                   <option value="">{t("tutor.form.sections.budget_requirements.options.any")}</option>
//                   {["BUET", "Medical", "DU", "Public University", "Private University"].map((opt) => (
//                     <option key={opt} value={opt}>
//                       {opt}
//                     </option>
//                   ))}
//                 </select> */}
//                 <select
//                   id="university"
//                   value={formData.tutorRequirements.university}
//                   onChange={(e) => updateFormData("tutorRequirements", { university: e.target.value })}
//                 >
//                   <option value="">{t("tutor.form.sections.budget_requirements.options.any")}</option>
//                   {UNI_OPTIONS.map((opt) => (
//                     <option key={opt.value} value={opt.value}>
//                       {opt.label}
//                     </option>
//                   ))}
//                 </select>

//               </div>

//               <div className="TutorService-optionGroup">
//                 {/* <label htmlFor="gender">
//                   {t("tutor.form.sections.budget_requirements.labels.gender")}
//                 </label> */}

//                 <label htmlFor="gender" className="tooltip-label">
//         {t("tutor.form.sections.budget_requirements.labels.gender")}
//         <ServiceTooltip
//           title={t("tutor.tooltips.gender.title")}
//           description={t("tutor.tooltips.gender.description")}
//         />
//       </label>

//                 <select
//                   id="gender"
//                   value={formData.tutorRequirements.gender}
//                   onChange={(e) => updateFormData("tutorRequirements", { gender: e.target.value })}
//                 >
//                   <option value="">{t("tutor.form.sections.budget_requirements.options.any")}</option>
//                   <option value="Male">{t("tutor.form.sections.budget_requirements.options.male")}</option>
//                   <option value="Female">{t("tutor.form.sections.budget_requirements.options.female")}</option>
//                 </select>
//               </div>
//             </div>

//             <div className="TutorService-serviceOptions">
//               <div className="TutorService-optionGroup TutorService-fullWidth">
//                 <label htmlFor="notes">
//                   <i className="fas fa-comment-alt" />
//                   {t("tutor.form.labels.notes")}
//                 </label>
//                 <textarea
//                   id="notes"
//                   value={formData.notes}
//                   onChange={(e) => updateFormData("notes", e.target.value)}
//                   placeholder={t("tutor.form.placeholders.notes")}
//                   className="TutorService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             {rebookState && prevTutorName && (
//               <div className="TutorService-rebookTutor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameTutor}
//                     onChange={() => setUseSameTutor(!useSameTutor)}
//                   />
//                   <span className="TutorService-rebookText">
//                     {t("tutor.form.rebook_same_tutor_prefix")}
//                     <span className="TutorService-strongName">{prevTutorName}</span>
//                     {t("tutor.form.rebook_same_tutor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             <div className="TutorService-priceDisplay">
//               <span>{t("tutor.form.price_display", { price: formData.salaryPerMonth })}</span>
//             </div>

//             <div className="TutorService-bookingDetails">
//               <div className="TutorService-optionGroup">
//                 {/* <label htmlFor="date">{t("tutor.form.booking_details.labels.date")}</label> */}
//                 <label htmlFor="date" className="tooltip-label">
//       {t("tutor.form.booking_details.labels.date")}
//       <ServiceTooltip
//         title={t("tutor.tooltips.preferredDate.title")}
//         description={t("tutor.tooltips.preferredDate.description")}
//       />
//     </label>
//                 <div className="TutorService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t("tutor.form.booking_details.date_placeholder")}
//                     className="TutorService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="TutorService-dateIcon"
//                     onClick={() =>
//                       document.querySelector(".react-datepicker__input-container input").click()
//                     }
//                   />
//                 </div>
//               </div>

//               <div className="TutorService-optionGroup">
//                 {/* <label htmlFor="time">{t("tutor.form.booking_details.labels.time")}</label> */}
//                 <label htmlFor="time" className="tooltip-label">
//       {t("tutor.form.booking_details.labels.time")}
//       <ServiceTooltip
//         title={t("tutor.tooltips.preferredTime.title")}
//         description={t("tutor.tooltips.preferredTime.description")}
//       />
//     </label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <button type="submit" className="TutorService-actionBtn">
//               {t(rebookState ? "tutor.form.rebook_button" : "tutor.form.submit_button")}
//             </button>
//           </form>

//           <div className="TutorService-infoBox">
//             <h4>{t("tutor.info_box.title")}</h4>
//             <p>{t("tutor.info_box.description")}</p>
//           </div>

//           <div className="TutorService-additionalInfo">
//             <div className="TutorService-sectionCard">
//               <h2 className="TutorService-sectionTitle">{t("tutor.additional_info.how_to_place_order.title")}</h2>
//               <ol className="TutorService-stepList">
//                 {t("tutor.additional_info.how_to_place_order.steps", { returnObjects: true }).map((step, index) => (
//                   <li key={index}>{step}</li>
//                 ))}
//               </ol>
//             </div>

//             <div className="TutorService-row2col">
//               <div className="TutorService-sectionCard TutorService-gradientBg2">
//                 <h2 className="TutorService-sectionTitle">{t("tutor.additional_info.why_choose_HelpNao.title")}</h2>
//                 <p className="TutorService-sectionText">{t("tutor.additional_info.why_choose_HelpNao.description")}</p>
//                 <div className="TutorService-featureGrid">
//                   {t("tutor.additional_info.why_choose_HelpNao.features", { returnObjects: true }).map((feature, index) => (
//                     <div className="TutorService-featureItem" key={index}>
//                       <i
//                         className={`fas fa-${
//                           index === 0 ? "chalkboard-teacher" : index === 1 ? "user-check" : index === 2 ? "clock" : "thumbs-up"
//                         } TutorService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="TutorService-sectionCard TutorService-gradientBg">
//                 <h2 className="TutorService-sectionTitle">{t("tutor.additional_info.key_features.title")}</h2>
//                 <div className="TutorService-featureGrid">
//                   {t("tutor.additional_info.key_features.features", { returnObjects: true }).map((feature, index) => (
//                     <div className="TutorService-featureItem" key={index}>
//                       <i
//                         className={`fas fa-${
//                           index === 0 ? "check-circle" : index === 1 ? "shield-alt" : index === 2 ? "laptop" : "headset"
//                         } TutorService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="TutorService-sectionCard TutorService-gradientBg3">
//               <h2 className="TutorService-sectionTitle">{t("tutor.additional_info.order_tracking.title")}</h2>
//               <div className="TutorService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="TutorService-sectionText TutorService-centerText">
//                 {t("tutor.additional_info.order_tracking.description")}
//               </p>
//             </div>
//           </div>
//         </div>

//         {showOrderForm && (
//           <TutorOrderForm
//             user={user}
//             formData={formData}
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit} // <- parent reset after success
//             previousTutorName={prevTutorName}
//           />
//         )}

//         {showLoginPrompt && <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />}
//       </div>

//       <div className="TutorService-feedback-section">
//         <FeedbackPage serviceType="Tutor Service" />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default TutorService;







// ***** Updated (30-Oct-2025) ***** //

import React, { useState, useEffect, useMemo, useRef } from "react";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import PromptLoginCard from "../PromptLoginCard";
import FeedbackPage from "../../Feedback/FeedbackPage";
import Footer from "../../../Components/Footer/Footer";
import TutorOrderForm from "./TutorserviceOrderForm";
import heroImage from "../images/Tutor.png";
import "./tutorserviceStyle.css";
import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
import Loader from "../../../Components/LoaderSpin/Loader";

/* ---------- constants at module scope ---------- */
const classLevels = {
  "Bangla Medium": [
    "KG","Nursery","Play","Class 1","Class 2","Class 3","Class 4","Class 5",
    "Class 6","Class 7","Class 8","Class 9","Class 10","SSC","HSC 1st Year",
    "HSC 2nd Year","Admission Test",
  ],
  "English Medium": [
    "Play","KG","Nursery","Standard 1","Standard 2","Standard 3","Standard 4",
    "Standard 5","Standard 6","Standard 7","Standard 8","Standard 9","Pre-Schooling",
    "O Level","A Level (AS)","A Level (A2)",
  ],
  "English Version": [
    "KG","Nursery","Play","Class 1","Class 2","Class 3","Class 4","Class 5",
    "Class 6","Class 7","Class 8","Class 9","Class 10","SSC","HSC 1st Year",
    "HSC 2nd Year","Admission Test",
  ],
};

const subjectsList = [
  "All",
  "Quran Sharif Learning",
  "Bangla",
  "English",
  "Mathematics",
  "General Science",
  "Social Science",
  "Religion",
  "ICT",
  "Higher Mathematics",
  "Physics",
  "Chemistry",
  "Biology",
  "Economics",
  "Statistics",
  "Psychology",
];

const MIN_SALARY = 1000;
/* ---------------------------------------------- */

const TutorService = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const rebookState = location.state?.fromRebook || false;
  const prevOrder = useMemo(
    () => location.state?.previousOrder || {},
    [location.state?.previousOrder]
  );

  const [ratingData, setRatingData] = useState({ reviewCount: 0, avgRating: 0 });
  const [useSameTutor, setUseSameTutor] = useState(false);
  const [prevTutorName, setPrevTutorName] = useState("");
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  // NEW: inline error state for salary
  const [salaryError, setSalaryError] = useState("");

  const [formData, setFormData] = useState({
    medium: "Bangla Medium",
    classLevel: "",
    subjects: [],
    daysPerWeek: 1,
    hoursPerDay: "1",
    salaryPerMonth: "",
    tutorRequirements: { university: "", gender: "" },
    notes: "",
    date: "",
    time: "",
    useSameTutor: false,
    servitor_id: undefined,
    price: 0,
  });


  // refs for focusing/scrolling
const classLevelRef = useRef(null);  // react-select
const subjectsRef   = useRef(null);  // react-select
const hoursRef      = useRef(null);  // <select>
const salaryRef     = useRef(null);  // <input type="number">
const timeRef       = useRef(null);  // <select id="time">

// smooth scroll helpers
const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "center" });
const scrollToEl = (el) => el?.scrollIntoView?.({ behavior: "smooth", block: "center" });

// validate + focus/scroll first invalid field
const validateAndFocus = () => {
  if (!formData.classLevel) {
    classLevelRef.current?.focus?.();
    scrollToId("classLevel");             // uses react-select's inputId
    return false;
  }
  if (!formData.subjects.length) {
    subjectsRef.current?.focus?.();
    scrollToId("subjects");
    return false;
  }
  if (!formData.hoursPerDay) {
    hoursRef.current?.focus?.();
    scrollToEl(hoursRef.current);
    return false;
  }
  if (formData.salaryPerMonth === "" || Number(formData.salaryPerMonth) < MIN_SALARY) {
    setSalaryError(`Please set at least ${MIN_SALARY}+ salary.`);
    salaryRef.current?.focus?.();
    scrollToEl(salaryRef.current);
    return false;
  }
  if (!timeRef.current?.value) {
    timeRef.current?.focus?.();
    scrollToEl(timeRef.current);
    return false;
  }
  return true;
};

  const getInitialDate = () => {
    const now = new Date();
    const currentHour = now.getHours();
    if (currentHour < 7 || currentHour >= 21) {
      const tomorrow = new Date();
      tomorrow.setDate(now.getDate() + 1);
      return tomorrow;
    }
    return now;
  };
  const [selectedDate, setSelectedDate] = useState(getInitialDate());

  // Load user and previous servitor (if rebook)
  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decoded = jwtDecode(token);
          const userIdRaw = decoded.Id;
          const extractedUserId = userIdRaw?.startsWith("user-")
            ? userIdRaw.split("user-")[1]
            : userIdRaw;

          const userRes = await axios.get(`${URL}/user/${extractedUserId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(userRes.data);
        } else {
          setUser(null);
        }

        if (rebookState && prevOrder.servitor_id) {
          try {
            const s = await axios.get(`${URL}/servitors/${prevOrder.servitor_id}`);
            const data = s.data;
            setPrevTutorName(`${data.FirstName} ${data.LastName}`);
          } catch (e) {
            console.error("Error fetching servitor:", e);
          }
        }
      } catch (err) {
        console.error("Init error:", err);
        if (!user) setShowLoginPrompt(true);
      } finally {
        setLoading(false);
      }
    };
    run();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rebookState, prevOrder.servitor_id]);

  // Ratings
  useEffect(() => {
    const loadRatings = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${URL}/api/ratings`);
        const tutorRatings = data["tutor service"] || {};
        setRatingData({
          reviewCount: tutorRatings.reviewCount || 0,
          avgRating: tutorRatings.avgRating || 0,
        });
      } catch (err) {
        console.error("Failed to load ratings:", err);
      } finally {
        setLoading(false);
      }
    };
    loadRatings();
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) stars.push(<FaStar key={i} />);
      else if (rating >= i - 0.5) stars.push(<FaStarHalfAlt key={i} />);
      else stars.push(<FaRegStar key={i} />);
    }
    return stars;
  };

  // prevent 21:30
  const generateTimeSlots = (dateObj) => {
    const startTime = 7;
    const endTime = 21; // last is 21:00
    const slots = [];
    const now = new Date();
    const todayStr = now.toISOString().split("T")[0];
    const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

    let startHour = startTime;
    let startMinute = 0;

    if (selectedDateStr === todayStr) {
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      if (currentHour >= endTime) return [];
      if (currentHour >= startTime) {
        if (currentMinute === 0) {
          startHour = currentHour;
          startMinute = 30;
        } else if (currentMinute <= 30) {
          startHour = currentHour;
          startMinute = 30;
        } else {
          startHour = currentHour + 1;
          startMinute = 0;
        }
      }
    }

    for (let hour = startHour; hour <= endTime; hour++) {
      const minuteStart = hour === startHour ? startMinute : 0;
      for (let minute = minuteStart; minute < 60; minute += 30) {
        if (hour === endTime && minute > 0) break; // stop 21:30
        if (selectedDateStr === todayStr) {
          const slotTime = new Date(now);
          slotTime.setHours(hour, minute, 0, 0);
          if (slotTime <= now) continue;
        }
        const displayHour = hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedTime = `${displayHour}:${String(minute).padStart(2, "0")} ${ampm}`;
        slots.push(formattedTime);
      }
    }
    return slots;
  };

  const updateFormData = (key, value) => {
    if (key === "tutorRequirements") {
      setFormData((prev) => ({
        ...prev,
        tutorRequirements: { ...prev.tutorRequirements, ...value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [key]: value }));
    }
  };

  // Populate from previous order on rebook
  useEffect(() => {
    if (rebookState && prevOrder) {
      setFormData((prev) => ({
        ...prev,
        medium: prevOrder.medium || "Bangla Medium",
        classLevel: prevOrder.classLevel || "",
        subjects: prevOrder.subjects || [],
        daysPerWeek: prevOrder.daysPerWeek || 1,
        hoursPerDay: prevOrder.hoursPerDay || "1",
        salaryPerMonth: prevOrder.salaryPerMonth || "",
        tutorRequirements: prevOrder.tutorRequirements || { university: "", gender: "" },
        notes: prevOrder.notes || "",
      }));
      setSalaryError(""); // reset salary error on load
    }
  }, [rebookState, prevOrder]);

  // NEW: live salary validation
  const handleSalaryChange = (e) => {
    const valStr = e.target.value; // keep string so user can clear input
    if (valStr === "") {
      updateFormData("salaryPerMonth", "");
      setSalaryError("");
      return;
    }
    const num = Number(valStr);
    if (Number.isNaN(num)) {
      // type="number" should prevent this, but just in case
      setSalaryError(`Please enter a valid number (minimum ${MIN_SALARY}).`);
      return;
    }
    updateFormData("salaryPerMonth", num);
    if (num < MIN_SALARY) {
      setSalaryError(`Please set at least ${MIN_SALARY}+ salary.`);
    } else {
      setSalaryError("");
    }
  };

  // const validateForm = () => {
  //   if (!formData.medium) return t("tutor.form.errors.medium");
  //   if (!formData.classLevel) return t("tutor.form.errors.classLevel");
  //   if (!formData.subjects.length) return t("tutor.form.errors.subjects");
  //   if (!formData.daysPerWeek) return t("tutor.form.errors.daysPerWeek");
  //   if (!formData.hoursPerDay) return t("tutor.form.errors.hoursPerDay");
  //   if (formData.salaryPerMonth === "" || formData.salaryPerMonth === null)
  //     return t("tutor.form.errors.salaryPerMonth");
  //   if (Number(formData.salaryPerMonth) < MIN_SALARY)
  //     return `Please set at least ${MIN_SALARY}+ salary.`;
  //   return null;
  // };

  // react-select theming + left align
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "var(--success)" : "#ddd",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(39, 174, 96, 0.2)" : "none",
      minHeight: 44,
      borderRadius: "var(--radius)",
      background: "#fff",
      textAlign: "left",
    }),
    valueContainer: (base) => ({
      ...base,
      justifyContent: "flex-start",
      textAlign: "left",
    }),
    singleValue: (base) => ({
      ...base,
      marginLeft: 0,
      textAlign: "left",
    }),
    placeholder: (base) => ({
      ...base,
      marginLeft: 0,
      textAlign: "left",
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f1f5f9" : "#fff",
      color: "var(--primary)",
      textAlign: "left",
    }),
    multiValue: (base) => ({ ...base, background: "#e6f3fa", borderRadius: 14 }),
    multiValueLabel: (base) => ({ ...base, color: "var(--primary)", fontWeight: 500 }),
    multiValueRemove: (base) => ({ ...base, color: "var(--accent)" }),
  };

  const classLevelOptions = useMemo(
    () => (classLevels[formData.medium] || []).map((opt) => ({ value: opt, label: opt })),
    [formData.medium]
  );

  const subjectOptions = useMemo(
    () => subjectsList.map((s) => ({ value: s, label: s })),
    []
  );

  const handleSubjectsChange = (selected) => {
    const vals = (selected || []).map((o) => o.value);
    const withoutAll = vals.filter((v) => v !== "All");
    // const allRealSubjects = subjectsList.filter((s) => s !== "All");

    if (vals.includes("All")) {
      // const alreadyAll = formData.subjects.length === allRealSubjects.length;
      // updateFormData("subjects", alreadyAll ? [] : allRealSubjects);
      updateFormData("subjects", "All");
    } else {
      updateFormData("subjects", withoutAll);
    }
  };

  // const selectedSubjectsValue = useMemo(
  //   () => formData.subjects.map((s) => ({ value: s, label: s })),
  //   [formData.subjects]
  // );

  const selectedSubjectsValue = useMemo(() => {
    // If user chose "All", show only one chip: All
    if (formData.subjects === "All") {
      return [{ value: "All", label: "All" }];
    }

    // Normal case: array of subjects
    if (Array.isArray(formData.subjects)) {
      return formData.subjects.map((s) => ({ value: s, label: s }));
    }

    // Fallback: if backend gave a comma-separated string like "Bangla, English"
    if (typeof formData.subjects === "string" && formData.subjects.trim()) {
      return formData.subjects
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((s) => ({ value: s, label: s }));
    }

    return [];
  }, [formData.subjects]);

  const handleGetService = (e) => {
    e.preventDefault();
    // const error = validateForm();
    // if (error) return alert(error);
    if (!validateAndFocus()) return;

    const dateStr = selectedDate ? selectedDate.toISOString().split("T")[0] : "";
    const time = timeRef.current?.value || "";

    const updated = {
      ...formData,
      date: dateStr,
      time,
      price: formData.salaryPerMonth,
      useSameTutor,
      servitor_id: useSameTutor ? prevOrder.servitor_id : undefined,
    };
    setFormData(updated);

    if (user) setShowOrderForm(true);
    else setShowLoginPrompt(true);
  };

  const handleOrderSubmit = () => {
    setFormData({
      medium: "Bangla Medium",
      classLevel: "",
      subjects: [],
      daysPerWeek: 1,
      hoursPerDay: "1",
      salaryPerMonth: "",
      tutorRequirements: { university: "", gender: "" },
      notes: "",
      date: "",
      time: "",
      useSameTutor: false,
      servitor_id: undefined,
      price: 0,
    });
    setUseSameTutor(false);
    setSalaryError("");
    setShowOrderForm(false);
  };

  const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
    const handleIncrement = () => setValue(value < max ? value + 1 : value);
    const handleDecrement = () => setValue(value > min ? value - 1 : value);
    return (
      <div className="TutorService-plusMinusInput">
        <button
          type="button"
          className="TutorService-minusBtn"
          onClick={handleDecrement}
          disabled={value <= min}
          aria-label={`Decrease ${id} quantity`}
        >
          −
        </button>
        <span className="TutorService-valueDisplay">
          {value} {t("tutor.form.days")}
        </span>
        <button
          type="button"
          className="TutorService-plusBtn"
          onClick={handleIncrement}
          disabled={value >= max}
          aria-label={`Increase ${id} quantity`}
        >
          +
        </button>
      </div>
    );
  };

  // const UNI_OPTIONS = useMemo(
  //   () => [
  //     { value: "BUET", label: t("tutor.universities.buet", { defaultValue: "BUET" }) },
  //     { value: "Medical", label: t("tutor.universities.medical", { defaultValue: "Medical" }) },
  //     { value: "Quran", label: t("tutor.universities.madrasa", { defaultValue: "Quran/Islamic Education" }) },
  //     { value: "DU", label: t("tutor.universities.du", { defaultValue: "Dhaka University" }) },
  //     { value: "Public University", label: t("tutor.universities.public", { defaultValue: "Public University" }) },
  //     { value: "Private University", label: t("tutor.universities.private", { defaultValue: "Private University" }) },
  //   ],
  //   [t]
  // );

  return (
    <>
      <div className="TutorService-container">
        <Navbar />
        <Loader show={loading} />

        <div className="TutorService-card">
          <div className="TutorService-hero">
            <img src={heroImage} alt="Tutor Services Hero" />
          </div>

          <div className="TutorService-header">
            <h1>{t(rebookState ? "tutor.header.rebook_title" : "tutor.header.title")}</h1>
            <div className="TutorService-rating">{renderStars(ratingData.avgRating)}</div>
            <div className="TutorService-reviews">
              {ratingData.reviewCount.toLocaleString()} {t("tutor.reviewsLabel")}
            </div>
          </div>

          <form onSubmit={handleGetService} className="TutorService-form">
            <h3 className="TutorService-sectionTitle">
              <i className="fas fa-book" />
              {t("tutor.form.sections.academic_details.title")}
            </h3>

            <div className="TutorService-serviceOptions">
              <div className="TutorService-optionGroup TutorService-fullWidth">
                <label htmlFor="medium" className="tooltip-label">
                  {t("tutor.form.sections.academic_details.labels.medium")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.medium.title")}
                    description={t("tutor.tooltips.medium.description")}
                  />
                </label>
                <select
                  id="medium"
                  value={formData.medium}
                  onChange={(e) => {
                    updateFormData("medium", e.target.value);
                    updateFormData("classLevel", "");
                  }}
                  required
                  className="TutorService-wideSelect"
                >
                  <option value="Bangla Medium">
                    {t("tutor.form.sections.academic_details.options.bangla_medium")}
                  </option>
                  <option value="English Medium">
                    {t("tutor.form.sections.academic_details.options.english_medium")}
                  </option>
                  <option value="English Version">
                    {t("tutor.form.sections.academic_details.options.english_version")}
                  </option>
                </select>
              </div>

              {/* Class Level via react-select */}
              <div className="TutorService-optionGroup TutorService-fullWidth">
                <label htmlFor="classLevel" className="tooltip-label">
                  {t("tutor.form.sections.academic_details.labels.classLevel")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.classLevel.title")}
                    description={t("tutor.tooltips.classLevel.description")}
                  />
                </label>

                <Select
                  ref={classLevelRef}
                  inputId="classLevel"
                  name="classLevel"
                  classNamePrefix="rs"
                  styles={selectStyles}
                  options={classLevelOptions}
                  isClearable
                  placeholder={t("tutor.form.sections.academic_details.options.select")}
                  value={
                    formData.classLevel
                      ? { value: formData.classLevel, label: formData.classLevel }
                      : null
                  }
                  onChange={(opt) => updateFormData("classLevel", opt ? opt.value : "")}
                  menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                  menuPosition="fixed"
                />
              </div>

              {/* Subjects via react-select (multi) */}
              <div className="TutorService-optionGroup TutorService-fullWidth">
                <label htmlFor="subjects" className="tooltip-label">
                  {t("tutor.form.sections.academic_details.labels.subjects")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.subjects.title")}
                    description={t("tutor.tooltips.subjects.description")}
                  />
                </label>

                <Select
                  ref={subjectsRef}
                  inputId="subjects"
                  name="subjects"
                  classNamePrefix="rs"
                  styles={selectStyles}
                  options={subjectOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  placeholder={t("tutor.form.sections.academic_details.placeholders.subjects")}
                  value={selectedSubjectsValue}
                  onChange={handleSubjectsChange}
                  noOptionsMessage={() => t("tutor.form.sections.academic_details.no_subjects")}
                  menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                  menuPosition="fixed"
                />
              </div>
            </div>

            <h3 className="TutorService-sectionTitle">
              <i className="fas fa-calendar-week" />
              {t("tutor.form.sections.schedule.title")}
            </h3>

            <div className="TutorService-serviceOptions">
              <div className="TutorService-optionGroup">
                <label htmlFor="daysPerWeek" className="tooltip-label">
                  {t("tutor.form.sections.schedule.labels.daysPerWeek")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.daysPerWeek.title")}
                    description={t("tutor.tooltips.daysPerWeek.description")}
                  />
                </label>
                <PlusMinusInput
                  id="daysPerWeek"
                  value={formData.daysPerWeek}
                  setValue={(val) => updateFormData("daysPerWeek", val)}
                  min={1}
                  max={7}
                />
              </div>

              <div className="TutorService-optionGroup">
                <label htmlFor="hoursPerDay" className="tooltip-label">
                  {t("tutor.form.sections.schedule.labels.hoursPerDay")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.hoursPerDay.title")}
                    description={t("tutor.tooltips.hoursPerDay.description")}
                  />
                </label>
                <select
                  ref={hoursRef}
                  id="hoursPerDay"
                  value={formData.hoursPerDay}
                  onChange={(e) => updateFormData("hoursPerDay", e.target.value)}
                  required
                >
                  {["1", "1.5", "2", "2.5", "3"].map((opt) => (
                    <option key={opt} value={opt}>
                      {opt} {t("tutor.form.hours")}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <h3 className="TutorService-sectionTitle">
              <i className="fas fa-money-bill" />
              {t("tutor.form.sections.budget_requirements.title")}
            </h3>

            <div className="TutorService-serviceOptions">
              <div className="TutorService-optionGroup">
                <label htmlFor="salaryPerMonth" className="tooltip-label">
                  {t("tutor.form.sections.budget_requirements.labels.salaryPerMonth")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.salaryPerMonth.title")}
                    description={t("tutor.tooltips.salaryPerMonth.description")}
                  />
                </label>

                <input
                  ref={salaryRef}
                  id="salaryPerMonth"
                  type="number"
                  min={MIN_SALARY}
                  inputMode="numeric"
                  step="1"
                  title={`Minimum ${MIN_SALARY}`}
                  value={formData.salaryPerMonth}
                  onChange={handleSalaryChange}
                  placeholder={t("tutor.form.sections.budget_requirements.placeholders.salaryPerMonth")}
                  required
                />
                {salaryError && (
                  <div className="TutorService-fieldError">{salaryError}</div>
                )}
              </div>

              <div className="TutorService-optionGroup">
                <label htmlFor="university" className="tooltip-label">
                  {t("tutor.form.sections.budget_requirements.labels.university")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.university.title")}
                    description={t("tutor.tooltips.university.description")}
                  />
                </label>

                <select
                  id="university"
                  value={formData.tutorRequirements.university}
                  onChange={(e) => updateFormData("tutorRequirements", { university: e.target.value })}
                >
                  <option value="">{t("tutor.form.sections.budget_requirements.options.any")}</option>
                  {[
                    { value: "BUET", label: t("tutor.universities.buet", { defaultValue: "BUET" }) },
                    { value: "Medical", label: t("tutor.universities.medical", { defaultValue: "Medical" }) },
                    { value: "Quran", label: t("tutor.universities.madrasa", { defaultValue: "Quran/Islamic Education" }) },
                    { value: "DU", label: t("tutor.universities.du", { defaultValue: "Dhaka University" }) },
                    { value: "Public University", label: t("tutor.universities.public", { defaultValue: "Public University" }) },
                    { value: "Private University", label: t("tutor.universities.private", { defaultValue: "Private University" }) },
                  ].map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="TutorService-optionGroup">
                <label htmlFor="gender" className="tooltip-label">
                  {t("tutor.form.sections.budget_requirements.labels.gender")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.gender.title")}
                    description={t("tutor.tooltips.gender.description")}
                  />
                </label>

                <select
                  id="gender"
                  value={formData.tutorRequirements.gender}
                  onChange={(e) => updateFormData("tutorRequirements", { gender: e.target.value })}
                >
                  <option value="">{t("tutor.form.sections.budget_requirements.options.any")}</option>
                  <option value="Male">{t("tutor.form.sections.budget_requirements.options.male")}</option>
                  <option value="Female">{t("tutor.form.sections.budget_requirements.options.female")}</option>
                </select>
              </div>
            </div>

            <div className="TutorService-serviceOptions">
              <div className="TutorService-optionGroup TutorService-fullWidth">
                <label htmlFor="notes">
                  <i className="fas fa-comment-alt" />
                  {t("tutor.form.labels.notes")}
                </label>
                <textarea
                  id="notes"
                  value={formData.notes}
                  onChange={(e) => updateFormData("notes", e.target.value)}
                  placeholder={t("tutor.form.placeholders.notes")}
                  className="TutorService-textarea"
                  rows="2"
                />
              </div>
            </div>

            {rebookState && prevTutorName && (
              <div className="TutorService-rebookTutor">
                <label>
                  <input
                    type="checkbox"
                    checked={useSameTutor}
                    onChange={() => setUseSameTutor(!useSameTutor)}
                  />
                  <span className="TutorService-rebookText">
                    {t("tutor.form.rebook_same_tutor_prefix")}
                    <span className="TutorService-strongName">{prevTutorName}</span>
                    {t("tutor.form.rebook_same_tutor_suffix")}
                  </span>
                </label>
              </div>
            )}

            <div className="TutorService-priceDisplay">
              <span>{t("tutor.form.price_display", { price: formData.salaryPerMonth || 0 })}</span>
            </div>

            <div className="TutorService-bookingDetails">
              <div className="TutorService-optionGroup">
                <label htmlFor="date" className="tooltip-label">
                  {t("tutor.form.booking_details.labels.date")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.preferredDate.title")}
                    description={t("tutor.tooltips.preferredDate.description")}
                  />
                </label>
                <div className="TutorService-dateInputWrapper">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MMM-yyyy"
                    minDate={new Date()}
                    placeholderText={t("tutor.form.booking_details.date_placeholder")}
                    className="TutorService-dateInput"
                  />
                  <FaCalendarAlt
                    className="TutorService-dateIcon"
                    onClick={() =>
                      document.querySelector(".react-datepicker__input-container input").click()
                    }
                  />
                </div>
              </div>

              <div className="TutorService-optionGroup">
                <label htmlFor="time" className="tooltip-label">
                  {t("tutor.form.booking_details.labels.time")}
                  <ServiceTooltip
                    title={t("tutor.tooltips.preferredTime.title")}
                    description={t("tutor.tooltips.preferredTime.description")}
                  />
                </label>
                <select id="time" name="time" required ref={timeRef}>
                  {generateTimeSlots(selectedDate).map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button type="submit" className="TutorService-actionBtn">
              {t(rebookState ? "tutor.form.rebook_button" : "tutor.form.submit_button")}
            </button>
          </form>

          <div className="TutorService-infoBox">
            <h4>{t("tutor.info_box.title")}</h4>
            <p>{t("tutor.info_box.description")}</p>
          </div>

          <div className="TutorService-additionalInfo">
            <div className="TutorService-sectionCard">
              <h2 className="TutorService-sectionTitle">
                {t("tutor.additional_info.how_to_place_order.title")}
              </h2>
              <ol className="TutorService-stepList">
                {t("tutor.additional_info.how_to_place_order.steps", { returnObjects: true }).map(
                  (step, index) => (
                    <li key={index}>{step}</li>
                  )
                )}
              </ol>
            </div>

            <div className="TutorService-row2col">
              <div className="TutorService-sectionCard TutorService-gradientBg2">
                <h2 className="TutorService-sectionTitle">
                  {t("tutor.additional_info.why_choose_HelpNao.title")}
                </h2>
                <p className="TutorService-sectionText">
                  {t("tutor.additional_info.why_choose_HelpNao.description")}
                </p>
                <div className="TutorService-featureGrid">
                  {t("tutor.additional_info.why_choose_HelpNao.features", { returnObjects: true }).map(
                    (feature, index) => (
                      <div className="TutorService-featureItem" key={index}>
                        <i
                          className={`fas fa-${
                            index === 0
                              ? "chalkboard-teacher"
                              : index === 1
                              ? "user-check"
                              : index === 2
                              ? "clock"
                              : "thumbs-up"
                          } TutorService-featureIcon`}
                          aria-hidden="true"
                        ></i>
                        <p>{feature}</p>
                      </div>
                    )
                  )}
                </div>
              </div>

              <div className="TutorService-sectionCard TutorService-gradientBg">
                <h2 className="TutorService-sectionTitle">
                  {t("tutor.additional_info.key_features.title")}
                </h2>
                <div className="TutorService-featureGrid">
                  {t("tutor.additional_info.key_features.features", { returnObjects: true }).map(
                    (feature, index) => (
                      <div className="TutorService-featureItem" key={index}>
                        <i
                          className={`fas fa-${
                            index === 0 ? "check-circle" : index === 1 ? "shield-alt" : index === 2 ? "laptop" : "headset"
                          } TutorService-featureIcon`}
                          aria-hidden="true"
                        ></i>
                        <p>{feature}</p>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="TutorService-sectionCard TutorService-gradientBg3">
              <h2 className="TutorService-sectionTitle">
                {t("tutor.additional_info.order_tracking.title")}
              </h2>
              <div className="TutorService-orderTrackIcon">
                <i className="fas fa-file-alt" aria-hidden="true"></i>
              </div>
              <p className="TutorService-sectionText TutorService-centerText">
                {t("tutor.additional_info.order_tracking.description")}
              </p>
            </div>
          </div>
        </div>

        {showOrderForm && (
          <TutorOrderForm
            user={user}
            formData={formData}
            onClose={() => setShowOrderForm(false)}
            onSubmit={handleOrderSubmit}
            previousTutorName={prevTutorName}
          />
        )}

        {showLoginPrompt && <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />}
      </div>

      <div className="TutorService-feedback-section">
        <FeedbackPage serviceType="Tutor Service" />
      </div>

      <Footer />
    </>
  );
};

export default TutorService;
